import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * ExistingPassBanner — shown above tier selection when the logged-in user
 * already has a non-revoked pass for this event. Pure presentational.
 */
export default function ExistingPassBanner({ existingPass, onViewExistingPass }) {
  if (!existingPass) return null;
  return (
    <div className="bg-emerald-500/5 border border-emerald-500/20 rounded-sm p-4 flex items-center justify-between gap-3 mb-4" data-testid="existing-pass-banner">
      <div className="flex items-center gap-2">
        <CheckCircle className="w-5 h-5 text-emerald-400 flex-shrink-0" />
        <div>
          <p className="text-sm font-medium text-emerald-400">You already have a pass</p>
          <p className="text-xs text-[#777]">{existingPass.tier_name || 'General'}</p>
        </div>
      </div>
      <Button
        size="sm"
        onClick={() => onViewExistingPass(existingPass)}
        className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-sm text-xs"
        data-testid="view-existing-pass"
      >
        View Pass
      </Button>
    </div>
  );
}
